// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  min-height: 100vh;
  display: flex;
  background: #1a1b23;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Main Content */
.main-content {
  flex: 1 1;
  margin-left: 200px;
  padding: 8px 0;
  height: 100dvh;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  background: #1a1b23;
  display: flex;
  flex-direction: column;
}

/* Adjust main content when sidebar is collapsed */
.main-content.sidebar-collapsed {
  margin-left: 48px;
}

/* Loading state */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #64748b;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.06);
  border-top-color: #2873ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error state */
.error-container {
  background: rgba(248, 113, 113, 0.1);
  color: #fca5a5;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  border: 1px solid rgba(248, 113, 113, 0.2);
}

.retry-button {
  margin-top: 12px;
  padding: 8px 16px;
  background: rgba(248, 113, 113, 0.2);
  color: #fca5a5;
  border: 1px solid rgba(248, 113, 113, 0.3);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.retry-button:hover {
  background: rgba(248, 113, 113, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".dashboard-container {\n  min-height: 100vh;\n  display: flex;\n  background: #1a1b23;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  margin-left: 200px;\n  padding: 8px 0;\n  height: 100dvh;\n  overflow: hidden;\n  transition: margin-left 0.3s ease;\n  background: #1a1b23;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Adjust main content when sidebar is collapsed */\n.main-content.sidebar-collapsed {\n  margin-left: 48px;\n}\n\n/* Loading state */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #64748b;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(255, 255, 255, 0.06);\n  border-top-color: #2873ff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error state */\n.error-container {\n  background: rgba(248, 113, 113, 0.1);\n  color: #fca5a5;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.retry-button {\n  margin-top: 12px;\n  padding: 8px 16px;\n  background: rgba(248, 113, 113, 0.2);\n  color: #fca5a5;\n  border: 1px solid rgba(248, 113, 113, 0.3);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.retry-button:hover {\n  background: rgba(248, 113, 113, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
